var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Student } from '@/models/Student';
import NavigationCard from '@/components/NavigationCard.vue';
let Home = class Home extends Vue {
    // #endregion
    // #region @Refs
    // #endregion
    // #region Class properties
    // #endregion
    // #region Lifecycle Hooks / Init
    // #endregion
    // #region Class methods
    isHomeTab(tab) {
        return !(tab && tab.to && tab.to.split('/').length > 3);
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Student !== "undefined" && Student) === "function" ? _a : Object)
], Home.prototype, "student", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Array)
], Home.prototype, "tabs", void 0);
Home = __decorate([
    Component({
        components: {
            NavigationCard,
        },
    })
], Home);
export default Home;
